import { type MCPServerInfo } from '../../types';

const DatabricksServer: MCPServerInfo = {
  serverId: 'DATABRICKS',
  name: 'Databricks',
  slug: 'databricks',
  description: 'Databricks MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl:
      'https://github.com/RafaelCartenet/mcp-databricks-server.git',
    commitSha: '9bf4542',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['databricksHost', 'databricksToken', 'databricksSqlWarehouseId'],
    properties: {
      databricksHost: {
        type: 'string',
        description:
          "Databricks workspace URL (i.e. 'https://your-instance.cloud.databricks.com')",
        sensitive: false
      },
      databricksToken: {
        type: 'string',
        description:
          'Databricks personal access token or service principal token',
        sensitive: true
      },
      databricksSqlWarehouseId: {
        type: 'string',
        description: 'SQL Warehouse ID for executing queries',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default DatabricksServer;
